module.exports = __webpack_public_path__ + "img/qatar.98b79a37.svg";